import { connect } from "react-redux";
import { MeioPagViewProps, mapDispatchToMeioPagProps, mapStateToMeioPagProps } from "../meiopg.controll";
import { MeioPag } from "../meiopg.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { MeioPagCadastro } from "./meiopg.cad";

const columns: GridColDef[] = [
    { field: 'descricao', headerName: 'Descricão', flex: 3 },
    { field: 'perc_desc', headerName: 'Desconto', flex: 2, renderCell:(prm)=>prm.value + " %"  },
    { field: 'show_movel', headerName: 'Exibir App?', flex:2 ,renderCell:(prm)=>prm.value?"Sim":"Não" },
    { field: 'ativo', headerName: 'Ativo?', flex: 2, renderCell:(prm)=>prm.value?"Sim":"Não" },
    { field: 'obs', headerName: 'Observação', flex: 3 },
]

function MeioPagList(props: MeioPagViewProps) {
    const { meioPagActions,meioPagState } = props
    const { error, loading, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = meioPagState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = meioPagActions

    useEffect(()=>{
        read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        setShowCadModal(false)
    }

    function Cadastro() {
        return MeioPagCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            width:"sm",
            heigth: "auto",
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Meios de Pagamentos cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columns}
                rows={rows}
                loading={loading}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=> read()
                }}
                ListItemTextPrimary={(row: MeioPag) => <Typography component={"span"}>{row.descricao}</Typography>}
                ListItemTextSecondary={(row: MeioPag) =>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography component={"span"}>{row.perc_desc} %</Typography>
                    </Box>
                }
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToMeioPagProps,mapDispatchToMeioPagProps)(MeioPagList);
